import {Controller, useFormContext} from "react-hook-form";

import {ICalendarSliderProps} from "@pg-design/calendar-module";
import {CalendarSliderField} from "@pg-design/calendar-module";

interface IProps extends ICalendarSliderProps {
    name: string;
}

export const CalendarSliderControlled = (props: IProps) => {
    const {name, ...restProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            control={control}
            render={({field: {onChange}, fieldState}) => {
                const error = fieldState.error?.message;

                return <CalendarSliderField onChange={onChange} fieldState={error ? "error" : "default"} errorMessage={error} {...restProps} />;
            }}
            name={name}
        />
    );
};
import {Controller, useFormContext} from "react-hook-form";

import {ICalendarSliderProps} from "@pg-design/calendar-module";
import {CalendarSliderField} from "@pg-design/calendar-module";

interface IProps extends ICalendarSliderProps {
    name: string;
}

export const CalendarSliderControlled = (props: IProps) => {
    const {name, ...restProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            control={control}
            render={({field: {onChange}, fieldState}) => {
                const error = fieldState.error?.message;

                return <CalendarSliderField onChange={onChange} fieldState={error ? "error" : "default"} errorMessage={error} {...restProps} />;
            }}
            name={name}
        />
    );
};
